<div class="contenedor-noticia">
  <app-tipo-noticia-generico [type]="noticia?.tipo_estilo_noticia" [noticia]="noticia" [innerHeader]="noticia?.tipo_estilo_noticia == '1' || noticia?.tipo_estilo_noticia == '2' || noticia?.tipo_estilo_noticia == '4' ? false : true" [imagenes_relacionadas]="noticia?.img_relacionadas"></app-tipo-noticia-generico>

  <div class="row-2-columns contenedor-noticia tipo-noticia-{{ noticia?.tipo_estilo_noticia }}" id="adsense">
    <div class="section-noticia">
      <ng-container *ngIf="!isMobile && comentariosNoticia?.length > 0">
        <div class="section-comentarios">
          <button class="comments-button" (click)="scrollToComments()" aria-label="Ir a los comentarios">
            <app-icon-comments></app-icon-comments>
            {{ comentariosNoticia.length }} {{ comentariosNoticia.length == 1 ? "comentario" : "comentarios" }}
          </button>
        </div>
      </ng-container>

      <div class="section-autor row-2-columns autor-noticia">
        <ng-container *ngIf="!noticia?.idAgencia && noticia?.autor_anonimo == '0' && !noticia?.firma_externa">
          <a class="url-autor" [routerLink]="autorUrl()">
            <ng-container *ngIf="noticia?.imagen_autor">
              <app-skeleton-image [src]="noticia?.imagen_autor" [customClass]="'avatar_autor'" [alt]="'El autor es' + noticia?.nombre_autor" [size]="100" [height]="100"></app-skeleton-image>
            </ng-container>
            <span class="nombre-autor">{{ noticia?.nombre_autor }}</span>
          </a>
        </ng-container>

        <ng-container *ngIf="noticia?.nombre_agencia || (noticia?.autor_anonimo == '1' && !noticia?.firma_externa)">
          <a class="url-autor" [routerLink]="noticia?.nombre_agencia ? autorUrl() : ['/autor', 'tribuna']">
            <app-skeleton-image [src]="'https://tribuna.isquad.es/images/afiliacion/square_6d686a36686c66716679.jpeg'" [customClass]="'avatar_autor'" [alt]="'Tribuna'" [size]="100" [height]="100"></app-skeleton-image>
            <!-- Lo dejo comentado porque no he encontrado donde ver esto -->
            <!-- <img class="avatar_autor" mat-card-avatar loading="lazy" src="https://tribuna.isquad.es/images/afiliacion/square_6d686a36686c66716679.jpeg" alt="Tribuna" width="100%" height="100%" /> -->
            <span>{{ noticia?.nombre_agencia }}</span>
          </a>
        </ng-container>

        <ng-container *ngIf="!noticia?.idAgencia && noticia?.autor_anonimo == '0' && noticia?.firma_externa">
          <span class="nombre-autor">{{ noticia?.firma_externa }}</span>
        </ng-container>

        <!-- Esto no se si se usa -->
        <ng-container *ngIf="noticia?.nombre_autor">
          <a [routerLink]="autorUrl()" [attr.aria-label]="noticia?.nombre_autor">
            <div class="info_autor"></div>
          </a>
        </ng-container>

        <div class="publicacion-actualizacion">
          <time class="fecha" [attr.datetime]="dateToIso(noticia?.fecha)">
            <span class="dateTime__created">{{ formatDate(noticia?.fecha) | date: "EEEE d MMMM y, HH:mm" }}</span>
          </time>
          <ng-container *ngIf="isMobile && noticia?.fechaEdicion > noticia?.fecha && noticia?.fechaEdicion > noticia?.fechaCreacion">
            <div class="edicionContainer">
              <span class="title-fecha">Actualizado:</span>
              <time class="fecha" [attr.datetime]="dateToIso(noticia?.fecha)">
                <span class="dateTime__edited">{{ formatDate(noticia?.fechaEdicion) | date: "EEEE, d MMM y, HH:mm" }}</span>
              </time>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="row-2-columns">
        <div class="tts-noticia">
          <ng-container *ngIf="btnPlayTTS">
            <button (click)="leerTexto(noticia?.descripcionVideo)" class="audio-btn" aria-label="Leer noticia en voz alta">
              <app-icon-play [customClass]="'detalle_noticia-icon'"></app-icon-play>
            </button>
          </ng-container>
          <ng-container *ngIf="btnPauseTTS">
            <button (click)="pausarTexto()" class="audio-btn" aria-label="Pausar lectura de la noticia">
              <app-icon-pause [customClass]="'detalle_noticia-icon'"></app-icon-pause>
            </button>
          </ng-container>
          <div class="onda-sonido-tts"></div>
        </div>
        <ng-container *ngIf="!isMobile && noticia?.tiempo_lectura">
          <div class="tiempo_estimado">Lectura estimada: {{ noticia?.tiempo_lectura }} min.</div>
        </ng-container>
        <ng-container *ngIf="!isMobile">
          <app-rrss-buttons [url]="noticia?.urlNoticia" [text]="noticia?.tituloSeo"></app-rrss-buttons>
        </ng-container>
      </div>
      <ng-container *ngIf="isMobile">
        <div class="line"></div>
        <div class="wrap-rrss-comentarios">
          <app-rrss-buttons [url]="noticia?.urlNoticia" [text]="noticia?.tituloSeo"></app-rrss-buttons>
          <ng-container *ngIf="comentariosNoticia?.length > 0">
            <div>
              <div class="line-vertical"></div>
              <div class="section-comentarios">
                <button class="comments-button" (click)="scrollToComments()" aria-label="Ir a los comentarios">
                  <app-icon-comments></app-icon-comments>
                  {{ comentariosNoticia.length }} {{ comentariosNoticia.length === 1 ? "comentario" : "comentarios" }}
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="noticia?.tags?.length > 0 || noticia?.fechaEdicion">
        <div class="tags-edicion">
          <ng-container *ngIf="noticia?.tags.length > 0">
            <div class="list_tag">
              <ng-container *ngFor="let tag of noticia?.tags; trackBy: trackByTag">
                <a [routerLink]="['/tag', tag.nombre_tag | kebabCase]">
                  <span class="tag" [ngStyle]="{ color: tag?.color_text, 'background-color': tag?.color_back }">{{ tag.nombre_tag }}</span>
                </a>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="isMobile && noticia?.tiempo_lectura">
            <div>Lectura estimada: {{ noticia?.tiempo_lectura }} min.</div>
          </ng-container>
          <ng-container *ngIf="!isMobile && noticia?.fechaEdicion > noticia?.fecha && noticia?.fechaEdicion > noticia?.fechaCreacion">
            <div class="edicionContainer">
              <span class="text-bold">Última actualización: </span>
              <time class="fecha" [attr.datetime]="dateToIso(noticia?.fecha)">
                <span class="dateTime__edited">{{ formatDate(noticia?.fechaEdicion) | date: "EEEE, d MMMM y, HH:mm" }}</span>
              </time>
            </div>
          </ng-container>
        </div>
      </ng-container>

      <div #contenedorNoticia id="descripcion-noticia" [innerHTML]="secureDescription" class="descripcion-noticia"></div>

      <!-- Contenedor de publicidad taboola -->
      <div id="taboola-below-article-thumbnails" appTaboolaLazy class="taboola-sentinel"></div>

      <ng-container *ngIf="isPremium == 1">
        <div class="bloque-premium">
          <h2>Artículo exclusivo para usuarios registrados</h2>
          <div>Registrate de forma gratuita para poder acceder al contenido premium</div>
          <button mat-button (click)="openRegisterPage()" class="btn-registrarse">Registro gratuito</button><br />
          <span>¿Ya estás registrado? <a (click)="openLoginDialog()" class="btn-login">Inicia sesión</a>.</span>
        </div>
      </ng-container>
      <ng-container *ngIf="isMobile">
        <div id="publi-comentarios"></div>
      </ng-container>
      <ng-container *ngIf="rrssAbajo">
        <div class="rrssAbajo">
          <h4>Comparte esta noticia</h4>
          <app-rrss-buttons [url]="noticia?.urlNoticia" [text]="noticia?.tituloSeo"></app-rrss-buttons>
        </div>
      </ng-container>

      <ng-container *ngIf="nextPrevNoticias && (!detalleReelsEnabled || !isMobile || !isReels)">
        <app-next-prev [nextprev]="nextPrevNoticias"></app-next-prev>
      </ng-container>

      <ng-container *ngIf="noticia?.masInfo">
        <app-bloque-enlaces-noticias class="bloqueMasInfoMovil" [title]="'Más Info.'" [extra]="noticia?.masInfo"></app-bloque-enlaces-noticias>
      </ng-container>

      <ng-container *ngIf="isMobile && noticia?.idVideo">
        <app-comentarios [idVideo]="noticia.idVideo" [showRss]="true" [noticia]="noticia"></app-comentarios>
      </ng-container>

      <ng-container *ngIf="noticiasRelacionadas?.length > 0">
        <div #bloqueNoticiasRelacionadas id="bloque-noticias-relacionadas" class="bloque-ultimas-noticias">
          <div class="titulo-bloque">Noticias relacionadas</div>
          <app-fila-cuatro-columnas [noticias]="noticiasRelacionadas" [lazy]="true" [idStart]="0"></app-fila-cuatro-columnas>
        </div>
      </ng-container>

      <ng-container *ngIf="!detalleReelsEnabled || !isMobile || !isReels">
        <div #bloqueUltimasNoticias id="bloque-ultimas-noticias" class="bloque-ultimas-noticias">
          <div class="titulo-bloque">Últimas noticias de esta sección</div>
          <ng-container *ngIf="!isMobile">
            <app-fila-cuatro-columnas [noticias]="ultimosVideosSeccion" [idStart]="0" [lazy]="true" [size]="150"></app-fila-cuatro-columnas>
          </ng-container>
          <ng-container *ngIf="isMobile && !isReels">
            <app-noticias-horizontal [noticias]="ultimosVideosSeccion"></app-noticias-horizontal>
          </ng-container>
        </div>
      </ng-container>

      <ng-container *ngIf="!isMobile">
        <div class="bloque-enlaces-noticias">
          <app-bloque-enlaces-noticias id="loMasVisto" [data]="videosMasVisto" [title]="'Lo más visto'"></app-bloque-enlaces-noticias>
          <app-bloque-enlaces-noticias [data]="ultimosVideos" [title]="'Últimas noticias'"></app-bloque-enlaces-noticias>
        </div>
      </ng-container>
    </div>

    <ng-container *ngIf="!detalleReelsEnabled || !isMobile || !isReels">
      <div class="section-publicidad">
        <ng-container *ngIf="!isMobile && noticia?.idVideo">
          <app-comentarios [idVideo]="noticia.idVideo" [showRss]="true" [noticia]="noticia"></app-comentarios>
        </ng-container>
        <ng-container *ngIf="noticia?.masInfo">
          <app-bloque-enlaces-noticias class="bloqueMasInfo" [title]="'Más Info.'" [extra]="noticia?.masInfo"></app-bloque-enlaces-noticias>
        </ng-container>

        <div id="ROBA_1"></div>

        <ng-container *ngIf="isMobile && !isReels">
          <div id="bloque-ultimas-noticias" class="bloque-ultimas-noticias">
            <div class="titulo-bloque">Lo más visto</div>
            <app-noticias-horizontal [noticias]="videosMasVisto"></app-noticias-horizontal>
          </div>
        </ng-container>

        <div id="ROBA_2"></div>

        <ng-container *ngIf="isMobile && !isReels">
          <div id="bloque-ultimas-noticias" class="bloque-ultimas-noticias">
            <div class="titulo-bloque">Últimas noticias</div>
            <app-noticias-horizontal [noticias]="ultimosVideos"></app-noticias-horizontal>
          </div>
        </ng-container>

        <div id="ROBA_3"></div>
      </div>
    </ng-container>
  </div>
</div>

<ng-container *ngIf="detalleReelsEnabled && isMobile && isReels">
  <ng-container *ngIf="showKeepScrolling">
    <div id="keep-scrolling" class="keep-scrolling">
      <h3 class="keep-scrolling__text">Sigue bajando para enterarte de las últimas noticias</h3>
      <app-down-arrow [fill]="accentColor"></app-down-arrow>
    </div>
  </ng-container>
  <app-reels-loader appIntersectionScroll [newsId]="noticia?.idVideo" (exit)="onReelsExit()"></app-reels-loader>
</ng-container>

<ng-container *ngIf="!isWebView">
  <app-banner-app-mv></app-banner-app-mv>
</ng-container>
